// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-pricing[data-v-24a694c6]{background:#373161}@media(min-width:768px){.bg-pricing[data-v-24a694c6]{background:radial-gradient(circle at top,#302b58,#0a0810)}}", ""]);
// Exports
module.exports = exports;
